import { useRecordContext } from "react-admin";

import { SessionKind } from "../generated/graphql";
import { Activity } from "../lib/activityUtils";
import { Icon } from "./icons/Icon";
import { ParticipantsAvatarGroup } from "./ParticipantsAvatarGroup";

type Props = {
  // This type is not used in the component, it's required by react-admin to show the label in table header
  label: string;
};

export const ParticipantsField: React.FC<Props> = () => {
  const record = useRecordContext<Activity>();

  if (!record) {
    return null;
  }

  if (!record.participants || record.participants.length === 0) {
    return record.kind === SessionKind.Group ? <Icon type="group" size="large" alt="Group session" /> : null;
  }

  return <ParticipantsAvatarGroup participants={record.participants} displayLimit={2} />;
};
